import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ViewboxService {

	public readonly targetSelector: WritableSignal<string> = signal(null);

	public readonly redrawTick: WritableSignal<int> = signal(0);

	private _timeout: NodeJS.Timeout;

	public redraw(): void {
		// acts like a simple debounce on redraw to coalesce and update on the last call to redraw. 
		clearTimeout(this._timeout);
		this._timeout = setTimeout(() => {
			this.redrawTick.update(v => v + 1);
		}, 0);
	}

}

